import moment from 'moment';

export const isEmptyObject = (obj) => {
  if (obj) {
    return Object.values(obj).every((value) => {
      if (value === null || value === undefined || value === '') {
        return true;
      } else if (value instanceof Object) {
        return isEmptyObject(value);
      }

      return false;
    });
  } else {
    return true;
  }
};

export const isValidUrl = (value) => {
  let url;

  try {
    url = new URL(value);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
};

export const humanFileSize = (size) => {
  if (size < 1024) return size + ' B';
  let i = Math.floor(Math.log(size) / Math.log(1024));
  let num = size / Math.pow(1024, i);
  let round = Math.round(num);
  num = round < 10 ? num.toFixed(2) : round < 100 ? num.toFixed(1) : round;
  return `${num} ${'KMGTPEZY'[i - 1]}B`;
};

export const calculateAge = (birthdate) => {
  if (birthdate && typeof birthdate === 'string') {
    const date = moment(birthdate, 'DD/MM/YYYY').toDate();
    const ageDifMs = Date.now() - date.getTime();
    const ageDate = new Date(ageDifMs); // milliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  } else if (birthdate?.getTime()) {
    const ageDifMs = Date.now() - birthdate.getTime();
    const ageDate = new Date(ageDifMs); // milliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  } else {
    return '';
  }
};

export const addressText = (address) => {
  return address
    ? `${address?.line}, ${address?.ward?.name}, ${address?.district?.name}, ${address?.province?.name}, ${address?.country?.name}`
    : '';
};

export const periodTimeText = (startTime, endTime) => {
  return (
    startTime
      ? startTime.indexOf('00:00:00') > 0
        ? startTime.substring(0, 10)
        : startTime.substring(0, 16)
      : ''
  ).concat(
    endTime
      ? endTime.indexOf('00:00:00') > 0
        ? ' - '.concat(endTime.substring(0, 10))
        : ' - '.concat(endTime.substring(0, 16))
      : '',
  );
};
